import { render } from "./LessonCard.vue?vue&type=template&id=28bed797"
import script from "./LessonCard.vue?vue&type=script&lang=ts"
export * from "./LessonCard.vue?vue&type=script&lang=ts"

import "./LessonCard.vue?vue&type=style&index=0&id=28bed797&lang=scss"
script.render = render

export default script